import { reviews } from '@/mocks/articles';

export default function ReviewsSection() {
  const col1 = reviews.filter((_, i) => i % 3 === 0);
  const col2 = reviews.filter((_, i) => i % 3 === 1);
  const col3 = reviews.filter((_, i) => i % 3 === 2);

  return (
    <section className="py-12 md:py-16 bg-background-100">
      <div className="w-full px-4 md:px-6">
        <div className="mb-10">
          <span className="inline-block text-xs font-medium bg-secondary-100 text-secondary-700 rounded-full px-3 py-1 mb-4">
            瓜友口碑
          </span>
          <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-900">
            吃瓜群众都说好
          </h2>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4">
          {[col1, col2, col3].map((column, colIdx) => (
            <div key={colIdx} className="flex flex-col gap-4">
              {column.map((review) => (
                <div
                  key={review.id}
                  className="bg-background-50 rounded-lg p-5 hover:bg-background-200/70 transition-colors"
                >
                  <div className="flex items-center gap-3 mb-3">
                    <div
                      className="w-10 h-10 rounded-full flex items-center justify-center text-white text-sm font-bold flex-shrink-0"
                      style={{ backgroundColor: review.avatarColor }}
                    >
                      {review.name.charAt(0)}
                    </div>
                    <div>
                      <div className="text-sm font-medium text-foreground-900">{review.name}</div>
                      <div className="text-xs text-foreground-500">@{review.name.replace(/\s/g, '')}</div>
                    </div>
                  </div>
                  <p className="text-sm text-foreground-700 leading-relaxed">
                    &ldquo;{review.content}&rdquo;
                  </p>
                </div>
              ))}
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}